import * as tslib_1 from "tslib";
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { manageSecurity } from '../actions/manageSecurity';
import { viewActivity } from '../actions/viewActivity';
import { OptionDescription } from 'owa-options-controls';
var styles = require('./AccountSecurityOptionFull.scss');
var SecurityManageOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(SecurityManageOptionFull, _super);
    function SecurityManageOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecurityManageOptionFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.securityManageContainer },
                React.createElement("div", null,
                    React.createElement(OptionDescription, null, strings.options_premium_AdvancedSecurityContent_part2)),
                React.createElement("div", { className: styles.securityManage_btn_container },
                    React.createElement(PrimaryButton, { text: strings.options_premium_buttonText, "data-is-focusable": true, disabled: false, onClick: manageSecurity, className: styles.addNewItemButton }))),
            React.createElement("div", { className: styles.securityManageContainer },
                React.createElement("div", null,
                    React.createElement(OptionDescription, null, strings.options_premium_AdvancedSecurityContent_part3)),
                React.createElement("div", { className: styles.securityManage_btn_container },
                    React.createElement(PrimaryButton, { text: strings.options_premium_AdvancedSecurityContent_View, "data-is-focusable": true, disabled: false, onClick: viewActivity, className: styles.addNewItemButton })))));
    };
    return SecurityManageOptionFull;
}(React.Component));
export default SecurityManageOptionFull;
//# sourceMappingURL=AccountSecurityOptionFull.js.map